import { useCallback } from "react";

import { useEventTrackerService } from "@vahak/core/dist/_services/hooks/useEventTrackerService";

import { TrackEventHandler } from "../../../types/events";

/**
 * Shared app-provider wiring for compact posting/bidding flows.
 * Exposes the common GA/MoEngage trackEvent adapter used by both flows.
 *
 * Namespace loading is handled on demand when a modal opens (see compact providers)
 * and when TopNavV2 mounts (navigation).
 */
export function useCompactFlowAppTracker() {
    const { sendGAandMoEngageEvent } = useEventTrackerService();

    const trackEvent = useCallback<TrackEventHandler>(
        (eventName, data, trackGa = true, trackMo = true, trackFbCapi = false) => {
            sendGAandMoEngageEvent({ name: eventName, data }, trackGa, trackMo, trackFbCapi);
        },
        [sendGAandMoEngageEvent]
    );

    return { trackEvent };
}
